import { render, staticRenderFns } from "./proSon.vue?vue&type=template&id=40f4f5f2&scoped=true"
import script from "./proSon.vue?vue&type=script&lang=js"
export * from "./proSon.vue?vue&type=script&lang=js"
import style0 from "./proSon.vue?vue&type=style&index=0&id=40f4f5f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f4f5f2",
  null
  
)

export default component.exports